import { Capacitor } from '@capacitor/core';
import { useEffect, useRef, useState } from 'react';

import { setGCHeader } from '../../../front/src/services/axios';
import { initCapacitorServices } from '../services/capacitor/initCapacitorServices';

// Global flag to prevent multiple initializations of Capacitor services
let isCapacitorServicesInitialized = false;

export const useCapacitor = (websiteKey?: string, locale?: string) => {
  const isNativePlatform = Capacitor.isNativePlatform();
  const [isLoadingServices, setIsLoadingServices] = useState(true);
  const initRef = useRef(false);

  useEffect(() => {
    // If already initialized or not a native platform, do nothing
    if (initRef.current || !isNativePlatform) {
      setIsLoadingServices(false);
      return;
    }

    const initCapServices = async () => {
      try {
        // Mark as initializing
        initRef.current = true;

        // Identify requests as coming from the native app
        setGCHeader('X-Native-App', true);

        // Initialize the deep link handler if it's not already initialized
        if (!isCapacitorServicesInitialized) {
          await initCapacitorServices(websiteKey, locale);
          isCapacitorServicesInitialized = true;
        }
      } catch (error) {
        console.error('Error initializing Capacitor:', error);
        // In case of error, reset the flag to allow a new attempt
        initRef.current = false;
      } finally {
        setIsLoadingServices(false);
      }
    };

    initCapServices();
  }, [websiteKey, locale, isNativePlatform]);

  return { isNativePlatform, isLoadingServices };
};
